import type { Reaction } from "@charkour/react-reactions"
import { ReactionBarSelector } from "@charkour/react-reactions"
import {
  Chat,
  MaybeOptimisticChatTextMessage,
  ReactionKey,
} from "@lazarentertainment/public-chat-web"
import { isNotOptimisticMessage } from "@lazarentertainment/public-chat-web/dist/src/messagesState"
import Emoji from "node-emoji"

const AVAILABLE_REACTIONS: Array<{
  reactionKey: ReactionKey
  label?: string
}> = [
  {
    reactionKey: "heart",
    label: "Heart",
  },
  {
    reactionKey: "satisfied",
    label: "Laugh",
  },
  {
    reactionKey: "open_mouth",
    label: "Shock",
  },
  {
    reactionKey: "cry",
    label: "Sad",
  },
  {
    reactionKey: "angry",
    label: "Angry",
  },
  {
    reactionKey: "thumbsup",
    label: "+1",
  },
]

export const ReactionPicker = ({
  message,
  submitMessageReaction,
  closeMenu,
}: {
  message: MaybeOptimisticChatTextMessage
  submitMessageReaction: Chat["toggleReaction"]
  closeMenu: () => void
}) => (
  <ReactionBarSelector
    iconSize={20}
    style={{ margin: "8px" }}
    reactions={AVAILABLE_REACTIONS.map(
      ({ reactionKey, label }): Reaction => {
        return {
          node: (
            <div data-robot={`chat-reaction-${reactionKey}`}>
              {Emoji.get(reactionKey)}
            </div>
          ),
          label: label || reactionKey,
          key: reactionKey,
        }
      },
    )}
    onSelect={(reactionKey: ReactionKey) => {
      if (isNotOptimisticMessage(message)) {
        submitMessageReaction(reactionKey, message.timetoken)
      }

      closeMenu()
    }}
  />
)
